module.exports = __webpack_public_path__ + "static/img/1603_phase_function_Paper_PointsHejduk_Prediction.b570dd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1603_phase_function_Paper_PointsHejduk_Prediction.png
// module id = AQYb
// module chunks = 0